import Swal from 'sweetalert2';
import { Color } from '../../assets/colors';
import * as actionTypes from '../action-types';
import { postAPI, putAPI } from '../../utils/api-function';
import { toaster } from '../../services/toast-service';
import { login_time, userId } from '../../utils/constants';
import { call, put, takeLeading } from 'redux-saga/effects';
import { customer_login, customer_signup, get_customer_details, send_login_otp, update_customer_details } from '../../utils/api-routes';

//! Auth
function* sendLoginOtp(action) {
    try {
        const { payload } = action;
        const { data } = yield postAPI({ url: send_login_otp, payload: payload?.data });

        if (data?.status) {
            toaster.success({ text: "OTP Sent Successfully." });
            yield call(payload?.onComplete);
        } else {
            toaster.error({ text: data?.message });
        }

    } catch (error) {
        toaster.error({ text: error?.response?.data?.message ? error?.response?.data?.message : 'Failed To Sent OTP.' });
        console.log('Send Login OTP Saga Error ::: ', error?.response?.data);
    }
};

function* customerLogin(action) {
    try {
        const { payload } = action;
        const { data } = yield postAPI({ url: customer_login, payload: payload?.data });

        if (data?.status) {
            toaster.success({ text: 'You are logged in successfully.' });
            localStorage.setItem('phone', data?.data?.phone || '');
            localStorage.setItem(userId, data?.data?.phone || '');
            localStorage.setItem('token', data?.data?.accessToken || '');
            localStorage.setItem('userId', data?.data?._id || '');
            try {
                localStorage.removeItem('');
                localStorage.removeItem('undefined');
            } catch (_) {}
            // setCurrentUser(data?.data);
            if (payload?.setCurrentUserData) yield call(payload.setCurrentUserData, data?.data);

            // Immediately set customer details so header/puja/yatra update without waiting for getCustomerDetails API
            const loginUser = data?.data || {};
            const loginNormalised = {
                ...loginUser,
                firstname: loginUser?.firstName || loginUser?.name || loginUser?.phone || '',
                mobile: loginUser?.phone,
                userid: loginUser?._id,
            };
            yield put({ type: actionTypes.SET_CUSTOMER_DETAILS, payload: loginNormalised });
            // Persist to localStorage so session survives page reload / payment gateway redirect
            try { localStorage.setItem('customerData', JSON.stringify(loginNormalised)); } catch(_) {}

            // localStorage.setItem(login_time, data?.data?.Time);
            yield call(payload?.onComplete);
            yield put({ type: actionTypes.GET_CUSTOMER_DETAILS, payload: null });

        } else {
            toaster.error({ text: data?.message });
        }

    } catch (error) {
        toaster.error({ text: error?.response?.data?.message ? error?.response?.data?.message : 'Failed To Login' });
        console.log('Login Saga Error ::: ', error?.response?.data);
    }
};

function* customerSignup(action) {
    try {
        const { payload } = action;
        const { data } = yield postAPI({ url: customer_signup, payload: payload?.data });

        if (data?.status) {
            toaster.success({ text: "You've registered successfully!" });
            yield call(payload?.onComplete);
            yield put({ type: actionTypes.TOGGLE_LOGIN_MODAL, payload: true });
        } else {
            toaster.error({ text: data?.message });
        }

    } catch (error) {
        toaster.error({ text: error?.response?.data?.message ? error?.response?.data?.message : 'Failed To Registered.' });
        console.log('Signup Saga Error ::: ', error?.response?.data);
    }
};

function* customerLogout(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload);

        const result = yield Swal.fire({
            icon: "warning", text: "Do you want to logout ?", showConfirmButton: true, timer: 20000,
            confirmButtonText: "Yes", confirmButtonColor: Color.primary, cancelButtonText: "No", showCancelButton: true, confirmButtonColor: Color?.primary, cancelButtonColor: Color.darkgrey
        });

        if (result.isConfirmed) {
            // Don't wipe entire localStorage — that also clears language/translation cache.
            localStorage.removeItem('token');
            localStorage.removeItem('userId');
            localStorage.removeItem('phone');
            localStorage.removeItem('customerData');
            localStorage.removeItem('customerDetails');
            try {
                localStorage.removeItem('');
                localStorage.removeItem('undefined');
            } catch (_) {}
            yield put({ type: actionTypes.SET_CUSTOMER_DETAILS, payload: null });
            toaster.info({ text: 'Logout successfully' });
            yield call(payload?.onComplete);
        }

    } catch (error) {
        Swal.fire({ icon: "error", text: error?.response?.data ? error?.response?.data : 'Failed To Logout', showConfirmButton: false, timer: 2000, });
        console.log("Customer Logout Saga Error ::: ", error)
    }
};

//! Customer Detail
function* updateCustomerDetails(action) {
    try {
        const { payload } = action;
        const { data } = yield putAPI({ url: update_customer_details(payload?.data?.id), payload: payload?.data, project: 'Milan-Sathi' });

        if (data?.success) {
            toaster.success({ text: "Profile updated successfully!" });
            yield call(payload?.onComplete);
            yield put({ type: actionTypes.GET_CUSTOMER_DETAILS, payload: null });
        } else {
            toaster.error({ text: data?.message });
        }

    } catch (error) {
        toaster.error({ text: error?.response?.data?.message ? error?.response?.data?.message : 'Failed to update profile.' });
        console.log('Profile Update Saga Error ::: ', error?.response?.data);
    }
};

function* getCustomerDetails(action) {
    try {
        const { payload } = action;

        yield put({ type: actionTypes.SET_IS_LOADING, payload: true });
        const phoneVal = localStorage.getItem('phone') || localStorage.getItem(userId) || (localStorage.getItem('customerData') ? JSON.parse(localStorage.getItem('customerData') || '{}')?.mobile : null);
        const { data } = yield postAPI({ url: get_customer_details, payload: { phone: phoneVal } });
        console.log("Customer Details Saga ::: ", data);

        if (data?.status && data?.data) {
            const cust = data?.data || {};
            const normalised = {
                ...cust,
                firstname: cust?.firstName || cust?.name,
                lastname: cust?.lastName,
                mobile: cust?.phone,
                userid: cust?._id,
            };
            yield put({ type: actionTypes.SET_CUSTOMER_DETAILS, payload: normalised });
            yield put({ type: actionTypes.SET_MILAN_SATHI_CUSTOMER_DETAILS, payload: cust });
            if (payload?.setCurrentUserData) yield call(payload.setCurrentUserData, cust);
            // Update localStorage backup on successful restore
            try { localStorage.setItem('customerData', JSON.stringify(normalised)); } catch(_) {}
        } else {
            // Do NOT clear localStorage on API failure — keep token so user stays logged in.
            // Restore from localStorage backup if available
            const savedData = localStorage.getItem('customerData');
            if (savedData && localStorage.getItem('token')) {
                try {
                    const parsed = JSON.parse(savedData);
                    yield put({ type: actionTypes.SET_CUSTOMER_DETAILS, payload: parsed });
                    if (payload?.setCurrentUserData) yield call(payload.setCurrentUserData, parsed);
                } catch(_) {}
            }
        }
        yield put({ type: actionTypes.SET_IS_LOADING, payload: false });

    } catch (error) {
        console.log('Get Customer Details Saga Error ::: ', error?.response?.data);
    }
};

export default function* authSaga() {
    //! Auth
    yield takeLeading(actionTypes.SEND_LOGIN_OTP, sendLoginOtp);
    yield takeLeading(actionTypes.CUSTOMER_LOGIN, customerLogin);
    yield takeLeading(actionTypes.CUSTOMER_SIGNUP, customerSignup);
    yield takeLeading(actionTypes.CUSTOMER_LOGOUT, customerLogout);

    //! Customer Detail
    yield takeLeading(actionTypes.UPDATE_CUSTOMER_DETAILS, updateCustomerDetails);
    yield takeLeading(actionTypes.GET_CUSTOMER_DETAILS, getCustomerDetails);
};